import { toast } from "sonner";
import { TrendingUp } from "lucide-react";

export const celebrate = (delta, score) => {
  if (!(delta > 0)) return;
  toast.custom(() => (
    <div className="fade-up flex w-[340px] max-w-[90vw] items-center gap-4 rounded-2xl border border-[#D4AF37]/60 bg-[#18181B] p-4 shadow-[0_0_50px_-12px_rgba(212,175,55,0.7)]" data-testid="score-improvement-toast">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-[#9c7a1f] to-[#F3C649]">
        <TrendingUp className="h-6 w-6 text-black" />
      </div>
      <div className="min-w-0">
        <div className="font-display text-2xl font-semibold text-[#F3C649]" data-testid="score-improvement-delta">+{delta} pts</div>
        <div className="text-xs text-zinc-400">Your ATS pass rate climbed to <span className="font-mono text-zinc-200">{score}%</span>. Nice work.</div>
      </div>
    </div>
  ), { duration: 4500, position: window.innerWidth < 640 ? "top-center" : "top-right" });
};
